module.exports = __webpack_public_path__ + "static/media/be.b7477043.svg";